import { faFilter } from '@fortawesome/pro-solid-svg-icons';
import classNames from 'classnames';
import { useState } from 'react';
import styled from 'styled-components';

import { IconButton } from '@sorare/core/src/atoms/buttons/IconButton';
import { FullWidthContainer } from '@sorare/core/src/atoms/layout/FullWidthContainer';
import { Portal } from '@sorare/core/src/atoms/layout/Portal';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { FiltersDrawer } from '@sorare/core/src/components/FiltersDrawer';
import { FilterButton } from '@sorare/core/src/components/search/FilterButton';
import { useIsLaptop } from '@sorare/core/src/hooks/device/useIsLaptop';
import { tabletAndAbove } from '@sorare/core/src/style/mediaQuery';

interface Props {
  children: React.ReactNode;
  toolbar?: React.ReactNode;
  extraCta?: React.ReactNode;
}

const ButtonContainer = styled(Horizontal)`
  margin-bottom: var(--double-unit);
`;

const Content = styled(FullWidthContainer)`
  padding-bottom: var(--triple-unit);
  min-height: 100%;
`;

const StyledDrawer = styled(FiltersDrawer)`
  background: var(--c-black);
  width: 100%;
  padding: var(--double-unit) 0;
  --radio-padding: var(--unit);
  --c-radio-bg: transparent;
  @media ${tabletAndAbove} {
    width: 320px;
  }
`;

const StyledFilterButton = styled(FilterButton)`
  margin: 0;
`;

export const MyPage = ({ children, toolbar, extraCta }: Props) => {
  const [showFiltersDrawer, setShowFiltersDrawer] = useState(false);
  const isDesktopAndAbove = useIsLaptop();
  return (
    <>
      {!!isDesktopAndAbove && (!!toolbar || !!extraCta) && (
        <Portal id="my-sorare-filters">
          <Horizontal>
            {extraCta}
            {!!toolbar && (
              <IconButton
                icon={faFilter}
                size="small"
                color="quaternary"
                onClick={() => setShowFiltersDrawer(true)}
              />
            )}
          </Horizontal>
        </Portal>
      )}
      {!isDesktopAndAbove && (!!toolbar || !!extraCta) && (
        <Portal id="above-bottom-bar-portal">
          <ButtonContainer center>
            {extraCta}
            {!!toolbar && (
              <StyledFilterButton
                className={classNames({ center: !extraCta })}
                onClick={() => setShowFiltersDrawer(true)}
              />
            )}
          </ButtonContainer>
        </Portal>
      )}
      <StyledDrawer
        open={showFiltersDrawer}
        onClose={() => setShowFiltersDrawer(false)}
      >
        {toolbar}
      </StyledDrawer>
      <Content>{children}</Content>
    </>
  );
};
